import Vue from "vue";
import Router from "vue-router";
import home from "@/views/home";
import cases from "@/views/cases";
import details from "@/views/details";

import caseshl from "@/views/caseshl";
import caseswy from "@/views/caseswy";
import casesyl from "@/views/casesyl";
import caseszf from "@/views/caseszf";
import caseszx from "@/views/caseszx";
import casesds from "@/views/casesds";
import casestc from "@/views/casestc";
Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "home",
      component: home
    },
    {
      path: "/cases",
      name: "cases",
      component: cases
    },
    {
      path: "/details",
      name: "details",
      component: details
    },
    {
      path: "/caseshl",
      name: "caseshl",
      component: caseshl
    },
    {
      path: "/caseswy",
      name: "caseswy",
      component: caseswy
    },
    {
      path: "/casesyl",
      name: "casesyl",
      component: casesyl
    },
    {
      path: "/caseszf",
      name: "caseszf",
      component: caseszf
    },
    {
      path: "/caseszx",
      name: "caseszx",
      component: caseszx
    },
    {
      path: "/casesds",
      name: "casesds",
      component: casesds
    },
    {
      path: "/casestc",
      name: "casestc",
      component: casestc
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  } //router-link 跳转时默认在页面顶部
});



// WEBPACK FOOTER //
// ./src/router/index.js